import http from '../../http'

export async function getQuantityIndicators(id, period) {
  return http.get(
    `/general-indicators-BI/get-quantity?legacyEntityId=${id}&periodInDays=${period}`
  )
}

export async function getPercentageIndicators(id, period) {
  return http.get(
    `/general-indicators-BI/get-value?legacyEntityId=${id}&periodInDays=${period}`
  )
}
